import React from 'react'
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import "../ContentSeo/TitleDivSeo.css"

function ShowPhone(props) {


  return (
    <div  id={`section-${props.index}`}>
      <div style={{marginTop:"10px"}} className='TitleDivSeo'>
      <br /><br />
        <h3 style={{color:"#999999",textAlign:"right"}}>الهاتف المحمول</h3>
       <hr />
       <br />
      <div className="CARD">
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
        <h3>عرض الهاتف المحمول </h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor">
          <img className='ImageShowPhone' style={{height:"650px",
          border:"1px solid gray",borderRadius:"10px",padding:"20px"}} src={props.src} alt="phone show"/>
        </Typography>

</CardContent>
    </Card>
    </div>
    </div>
    </div>
  )
}
export default ShowPhone